/**
=========================================================
* Sidenav nav items — Figma dark sidebar + purple gradient active state.
=========================================================
*/
import { figmaTokens } from "assets/theme/designTokens";

const PRIMARY_GRADIENT = figmaTokens.gradientCSS;
const NAV_TEXT = figmaTokens.sidebarText;
const WHITE = "#ffffff";

function collapseItem(theme, ownerState) {
  const { transitions, breakpoints, borders, functions } = theme;
  const { active, transparentSidenav } = ownerState;

  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    background: active ? PRIMARY_GRADIENT : transparentSidenav ? "transparent" : "transparent",
    color: active ? WHITE : NAV_TEXT,
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(12)} ${pxToRem(16)}`,
    margin: `0 ${pxToRem(16)}`,
    borderRadius: borderRadius.lg,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active ? "0px 10px 7.5px rgba(0, 0, 0, 0.1)" : "none",
    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background", "color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },
    "&:hover": {
      background: active ? PRIMARY_GRADIENT : "rgba(148, 163, 184, 0.12)",
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { transitions, breakpoints, functions } = theme;
  const { active } = ownerState;

  const { pxToRem } = functions;

  return {
    background: "transparent !important",
    boxShadow: "none !important",
    minWidth: pxToRem(20),
    minHeight: pxToRem(20),
    borderRadius: 0,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up("xl")]: {
      background: "transparent !important",
    },

    "& .MuiIcon-root": {
      color: active ? WHITE : NAV_TEXT,
      fontSize: pxToRem(20),
    },

    "& svg, svg g": {
      fill: active ? WHITE : NAV_TEXT,
    },
  };
}

const collapseIcon = ({ palette: { white } }, { active }) => ({
  color: active ? white.main : NAV_TEXT,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(12),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: "0.875rem",
      lineHeight: 1.25,
      color: active ? `${WHITE} !important` : `${NAV_TEXT} !important`,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
